import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import Cart from "./pages/Cart";
import OrderHistory from "./pages/OrderHistory";
import OrderDetails from "./pages/OrderDetails";
import Checkout from "./pages/Checkout";
import AddressBook from "./pages/AddressBook";
import SearchResults from "./pages/SearchResults";
import ProductDetail from "./pages/ProductDetail";
import Header from "./components/Header";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import DashboardHome from "./pages/admin/DashboardHome";
import ProductManagement from "./pages/admin/ProductManagement";
import CategoriesManagement from "./pages/admin/CategoriesManagement";
import UsersManagement from "./pages/admin/UsersManagement";
import OrdersManagement from "./pages/admin/OrdersManagement";
import UnitsManagement from "./pages/admin/UnitsManagement";
import CouponsManagement from "./pages/admin/CouponsManagement";
import AdminRoute from "./components/AdminRoute";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";

export default function App() {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem("theme");
        return saved || "light";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    return (
        <Router>
            <AuthProvider>
                <CartProvider>
                    <Routes>
                        {/* Admin Routes - No Header */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={
                            <AdminRoute>
                                <AdminDashboard />
                            </AdminRoute>
                        }>
                            <Route index element={<DashboardHome />} />
                            <Route path="dashboard" element={<DashboardHome />} />
                            <Route path="products" element={<ProductManagement />} />
                            <Route path="products/new" element={<ProductManagement />} />
                            <Route path="orders" element={<OrdersManagement />} />
                            <Route path="orders/:orderId" element={<OrdersManagement />} />
                            <Route path="categories" element={<CategoriesManagement />} />
                            <Route path="units" element={<UnitsManagement />} />
                            <Route path="coupons" element={<CouponsManagement />} />
                            <Route path="users" element={<UsersManagement />} />
                        </Route>
                        
                        {/* Public Routes - With Header */}
                        <Route path="/*" element={
                            <>
                                <Header theme={theme} setTheme={setTheme} />
                                <main>
                                    <Routes>
                                        <Route path="/" element={<Home />} />
                                        <Route path="/category/:categorySlug" element={<CategoryPage />} />
                                        <Route path="/search" element={<SearchResults />} />
                                        <Route path="/product/:id" element={<ProductDetail />} />
                                        <Route path="/cart" element={<Cart />} />
                                        <Route path="/checkout" element={<Checkout />} />
                                        <Route path="/orders" element={<OrderHistory />} />
                                        <Route path="/orders/:orderId" element={<OrderDetails />} />
                                        <Route path="/addresses" element={<AddressBook />} />
                                    </Routes>
                                </main>
                            </>
                        } />
                    </Routes>
                </CartProvider>
            </AuthProvider>
        </Router>
    );
}
